import React, { ReactNode, Component } from 'react';
import { Overlay } from './styles';

export class Modal extends Component<Props, ModalState> {
  private static __instance: Modal;
  private overlay: React.RefObject<HTMLDivElement>;
  public constructor(props) {
    super(props);
    if (Modal.__instance) {
      return Modal.__instance;
    }

    this.state = {};
    this.overlay = React.createRef<HTMLDivElement>();
    Modal.__instance = this;
  }

  public render() {
    const { content } = this.state;

    if (!content) {
      return null;
    }

    return (
      <Overlay onClick={this.handleOverlayClick} ref={this.overlay}>
        {content}
      </Overlay>
    );
  }

  private __show(params: ShowModalParams) {
    const { content } = params;

    this.setState({
      content,
    });
  }

  private __hide() {
    this.setState({
      content: null,
    });
  }

  public static show(params: ShowModalParams) {
    Modal.__instance.__show(params);
  }

  public static hide() {
    Modal.__instance.__hide();
  }

  private handleOverlayClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === this.overlay.current) {
      this.__hide();
    }
  };
}

/** Type definitions */
interface ShowModalParams {
  /** Content to render on the modal */
  content?: ReactNode;
}

interface ModalState {
  /** Content to render on the modal */
  content?: ReactNode;
}

type Props = Record<string, unknown>;
